import React from 'react'

class Footer extends React.Component {
    render() {
        return (
            <section id="footer">
                <ul className="copyright">
                    <li>&copy; 2021 Jina Lee. All Rights reserved.</li><li>Design: Jina Lee</li>
                </ul>
            </section>
        )
    }
}

export default Footer
